import { Text } from "@chakra-ui/react";
import { useState, useEffect } from "react";

const AccountNameText = ({
  accountId,
  fallback = "", 
  size = "md",
}) => {
  const [name, setName] = useState(fallback);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAccount = async () => {
      if (!accountId) {
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(`https://ledgers.poc.mrc.ai/api/accounts/${accountId}`);
        if (!res.ok) throw new Error("Failed to fetch account");
        const account = await res.json();
        setName(account.name || fallback);
      } catch (error) {
        console.error("Failed to fetch account name:", error);
        setName(fallback);
      } finally {
        setLoading(false);
      }
    };

    fetchAccount();
  }, [accountId, fallback]);

  return (
    <Text fontSize={size} color="gray.500" mt={2}>
      {loading ? "Loading..." : name}
    </Text>
  );
};

export default AccountNameText;
